import React from "react";
import "./Home.css";

function Home() {
  return (
    <div className="home_layout">
      
    </div>
  );
}

export default Home;
